import { render } from "./DatasetMonitor.vue?vue&type=template&id=e12058f4"
import script from "./DatasetMonitor.vue?vue&type=script&lang=js"
export * from "./DatasetMonitor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__